"use strict";

exports.__esModule = true;
exports.FlexRowWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _FlexRowElement = require("./FlexRowElement");
var _FlexRowFields = require("./FlexRowFields");
var _FlexRowHeader = require("./FlexRowHeader");
var _FlexRowThumbnail = require("./FlexRowThumbnail");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FlexRowWidget = exports.FlexRowWidget = {
  name: "FlexRow",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "FlexRowWidget.label",
    defaultMessage: "Row"
  }),
  icon: "layout-linear",
  createElement: function createElement(props) {
    return {
      type: "FlexRow",
      props: Object.assign({
        width: 256,
        height: 64
      }, props),
      children: []
    };
  },
  showInPalette: false,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["gutter", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 3840
    },
    height: {
      "default": 64,
      min: 32,
      max: 2160
    }
  },
  components: {
    Header: _FlexRowHeader.FlexRowHeader,
    Element: _FlexRowElement.FlexRowElement,
    Fields: _FlexRowFields.FlexRowFields,
    Thumbnail: _FlexRowThumbnail.FlexRowThumbnail
  }
};